<template>
  <section class="notice-section">
    <div class="content-max-width">

      <h4 v-html="content"></h4>

      <a class="exit" @click="closePopup">
        <span></span>
        <span></span>
      </a>

    </div>
  </section>
</template>

<script>
  export default {
    props: {
      content: String
    },

    methods: {
      closePopup () {
        this.$store.commit('setNotice', {
          open: false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.notice-section {
  width: 100%;
	padding: 10px 30px;

  text-align: center;

	background: $color-3;

	@media (min-width: $mediumish) {
		padding: 10px 40px;
	}

	h4 {
    margin: 0;

		font-size: 16px;
		font-weight: 600;
		text-align: center;
		letter-spacing: -0.19px;
		line-height: 20px;
		color: white;
	}

  a {
    color: $color-2;
  }

  .exit {
    position: absolute;
    top: calc(50% - 14px);
    right: -20px;

    width: 28px;
    height: 28px;

    border: 1px solid white;
    border-radius: 50%;

    @media (min-width: $medium) {
      //top: -4px;
      right: 0;
    }

    span {
        position: absolute;
        top: 12px;
        left: 6px;

        display: inline-block;
        width: 14px;
        height: 2px;

        background: white;
        transform: rotate(45deg);
    }
    span:nth-of-type(2) { transform: rotate(-45deg); }
  }
}
</style>




// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PageNotice.vue